import { render, staticRenderFns } from "./AddSystem.vue?vue&type=template&id=6252964a&scoped=true"
import script from "./AddSystem.vue?vue&type=script&lang=js"
export * from "./AddSystem.vue?vue&type=script&lang=js"
import style0 from "./AddSystem.vue?vue&type=style&index=0&id=6252964a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6252964a",
  null
  
)

export default component.exports